/**
 * Component to handle organization bulk upload
 */
import * as React from 'react';
import { Card, Breadcrumb, Table, Checkbox, Row, Button, message } from 'antd';
import CSVReader from 'react-csv-reader';
import dataservice from '../../service/data.service';
import '../../css/ProfileBulkUpload.scss';
import { VIEWSTATE } from '../common/constants';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';
import LocalStorage from '../../service/localstorage';
import strings from '../../eyeguide-localization/organization/string.organization.upload';
import { CustomSorter } from '../Sorter';

const storage = new LocalStorage();
const SAMPLEFILE = require('../../sample/samplefile_org.csv');
const ERRORMSG = 'Invalid';
const REQUIREDKEYS = [
    'index',
    'name', 
    'contact_fname', 
    'contact_lname',
    'contact_phone',
    'contact_email'
];
const CSVIMAGE = require('../../sample/org_sample.JPG');
const EXCELIMAGE = require('../../sample/org_sample_excel.JPG');

interface IOrganizationBulkUploadProps {
    match: any;
    location: any;
    notifyOrgStatusChange: any;
}

interface IOrganizationBulkUploadState {
    rosterName: string;
    columns: Array<any>;
    columnData: Array<any>;
    loading: boolean;
    isHeader: boolean;
    pagination: any;
    isError: boolean;
    isValidationError: boolean;
    infoColumns: Array<any>;
    infoData: Array<any>;
    showInfo: boolean;
    successCount: number;
    btnDisable: boolean;
    clearBtnDisable: boolean;
}

export default class OrganizationBulkUpload 
            extends React.Component<IOrganizationBulkUploadProps, IOrganizationBulkUploadState> {

    constructor(props: IOrganizationBulkUploadProps) {
        super(props);
        this.state = {
            rosterName: '',
            columns: [],
            columnData: [],
            loading: false,
            isHeader: false,
            pagination: {},
            isError: false,
            infoColumns: this.getInfoColumns(),
            infoData: this.getInfoData(),
            showInfo: true,
            isValidationError: false,
            successCount: 0,
            btnDisable: false,
            clearBtnDisable: false
        };
        this.handleFileLoad = this.handleFileLoad.bind(this);
        this.uploadOrganizations = this.uploadOrganizations.bind(this);
    }

    componentDidMount() {
        strings.setLanguage(navigator.language);
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.ORGANIZATION);
        staticProperties.set(STATICKEYS.selectedRoster, '');
    }

    render() {
        console.log('length', this.state.columnData);
        return(
            <div className="ProfileBulkUpload"> 
                <Card>
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/organization">{strings.lsOrgsTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item>{strings.lsUploadTxt}</Breadcrumb.Item>
                    </Breadcrumb>
                    <br/>
                    <h3> {strings.lsUploadTxt} </h3>
                </Card>
                <Card bordered={false} style={{ margin: '24px 16px' }}> 

                    <CSVReader
                        cssClass="csv-input"
                        label={strings.lsSelectCSVTxt}
                        onFileLoaded={this.handleFileLoad}
                        onError={this.fileUploadError}
                    />
                    <Checkbox 
                        className="headerCheckbox" 
                        onChange={(val) => this.setState({isHeader: val.target.checked})}
                        checked={this.state.isHeader}
                    >
                        {strings.lsFirstRowHeaderChkBoxTxt} 
                    </Checkbox>
                    <Row>
                        <Button 
                            type="primary" 
                            onClick={() => this.clearForm()}
                            disabled={this.state.clearBtnDisable}
                        > 
                            {strings.lsClearTxt}
                        </Button>
                    </Row>
                    {this.state.showInfo ? 
                    <div className="infoText"> {strings.lsRowHeaderTxt} 
                           <b> {strings.lsRowHeaderColTxt} </b>
                        <Table
                            className="infoTable"
                            columns={this.state.infoColumns}
                            dataSource={this.state.infoData}
                            bordered={false}
                            pagination={false}
                        />
                        <div> {strings.lsCSVUploadInfoTxt1} </div>
                        <div className="divSampleFile"> 
                            {strings.formatString(strings.lsCSVUploadInfoTxt2, 
                                                  <a href={SAMPLEFILE}> {strings.lsHereTxt} </a> )}
                        </div>
                        <div>
                            {strings.lsCSVUploadInfoTxt3}
                        </div>
                        <div> <img src={CSVIMAGE}/> </div>
                        <div>{strings.lsCSVUploadInfoTxt4}</div>
                        <div><img src={EXCELIMAGE}/></div>
                    </div>
                    :
                    this.state.isError ? 
                    <div> 
                        {strings.lsUploadErrorTxt} 
                        <Table   
                            className="dataTable"              
                            columns={this.state.columns} 
                            dataSource={this.state.columnData} 
                            loading={this.state.loading}
                            rowClassName={(record, index) => 'rows'}
                            pagination={this.state.pagination}
                            rowKey={record => record.index}
                            bordered={true}
                            scroll={this.state.columnData.length > 0 ? { x: 1300 } : {}}
                        />         
                    </div>   :
                    <div>
                        <Row> 
                        {this.state.columnData.length === 0 ? '' :
                            <Button 
                                icon="upload"
                                className="downloadBtn"
                                type="primary" 
                                onClick={e => this.uploadOrganizations()}
                                disabled={this.state.btnDisable}
                            > 
                                {strings.lsUploadTxt}
                            </Button> }
                        </Row> 
                        {this.state.isValidationError ? 
                       <span>{this.state.successCount + ' Organization(s) were added to the system.' +
                            ' Below organization(s) were not added to the system:'} </span> : ''}
                        <Table   
                            className="dataTable"              
                            columns={this.state.columns} 
                            dataSource={this.state.columnData} 
                            loading={this.state.loading}
                            rowClassName={(record, index) => 'rows'}
                            pagination={this.state.pagination}
                            rowKey={record => record.index}
                            bordered={true}
                            scroll={{ x: 1600 }}
                        />    
                    </div>
                    }
                </Card>
            </div>
        );
    }

    /**
     * Displays and sets the data fetched from csv uploaded
     * @param data Data fetched from csv as array to upload
     */
    private handleFileLoad(data: any) {
        console.log('handleFileLoad', data);
        this.setState({
            columnData: [],
            showInfo: false
        });
        console.log(this.state.columnData);
        let columnData = this.buildData(data);
        console.log(columnData);
        let errorRows: any = [];
        errorRows = this.validateData(columnData);
        console.log('errorRows', errorRows);
        let columns = this.buildColumns();
        const pagination = { ...this.state.pagination };
        pagination.total = errorRows.length > 0 ? errorRows.length : columnData.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return `Total ${total} organizations`;
        };
        this.setState({
            columns,
            columnData: errorRows.length > 0 ? errorRows : columnData ,
            isError: errorRows.length > 0 ? true : false,
            pagination
        });
        
    }

    private fileUploadError() {
        console.log('fileUploadError');
        message.error('File upload failed. Please try again!');
    }

    /**
     * This function returns the column setting for use with the Table component
     * @param isError True, If uploaded data does not pass validation
     */
    private buildColumns(isError: boolean = false) {
        let columns: any = [
          { 
            title: 'Row Number',
            dataIndex: 'index',
            sorter: (a: any, b: any) => 
                parseInt(a.index, 10) < parseInt(b.index, 10) ? -1 : 1
            ,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Name',
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            className: 'rows',
            render: (text: any) => 
                text === ERRORMSG ? (
                
                <div
                    style={{color: 'red'}}
                >
                {text}
                </div>) : text ,
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Contact First Name',
            dataIndex: 'contact_fname',
            sorter: (a: any, b: any) => a.contact_fname.localeCompare(b.contact_fname),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : text ,
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Contact Last Name',
            dataIndex: 'contact_lname',
            sorter: (a: any, b: any) => a.contact_lname.localeCompare(b.contact_lname),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : text ,
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Contact Phone',
            dataIndex: 'contact_phone',
            sorter: (a: any, b: any) => a.contact_phone.localeCompare(b.contact_phone),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : text ,
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } ,
          {
            title: 'Contact Email',
            dataIndex: 'contact_email',
            sorter: (a: any, b: any) => a.contact_email.localeCompare(b.contact_email),
            className: 'rows',
            render: (text: any) => 
            text === ERRORMSG ? (
            
            <div
                style={{color: 'red'}}
            >
            {text}
            </div>) : text ,
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } ,
          {
            title: 'Address',
            dataIndex: 'address',
            sorter: (a: any, b: any) => a.address.localeCompare(b.address),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
            
          } ,
          {
            title: 'City',
            dataIndex: 'city',
            sorter: (a: any, b: any) => a.city.localeCompare(b.city),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
            
          } ,
          {
            title: 'State',
            dataIndex: 'state',
            sorter: (a: any, b: any) => a.state.localeCompare(b.state),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
            
          } ,
          {
            title: 'Country',
            dataIndex: 'country',
            sorter: (a: any, b: any) => a.country.localeCompare(b.country),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
            
          } ,
          {
            title: 'Zip/Postal Code',
            dataIndex: 'pincode',
            sorter: (a: any, b: any) => a.pincode.localeCompare(b.pincode),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
            
          } ,
          {
            title: 'Email',
            dataIndex: 'email',
            sorter: (a: any, b: any) => a.email.localeCompare(b.email),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Website',
            dataIndex: 'website',
            sorter: (a: any, b: any) => a.website.localeCompare(b.website),
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          }
        ];
        console.log('this.state.columnData', this.state.columnData);
        if ( isError ) {
            columns.push( {
                                title: 'Error Msg(s)',
                                dataIndex: 'error',
                                className: 'errorCol',
                                render: (text: any) => 
                                text.map((e: any) => 
                                    (
                                    <div>
                                    {e}
                                </div> ))
                            });
        }

        return columns;
    }

    /**
     * This function builds the data required by the Table component to display the organizations
     * @param orgs Organization array containing the organizations to be dispalyed
     */
    private buildData(orgs: Array<any>) {
        let columnData: Array<any> = [];
        if (orgs !== null) {
            let i = 0;
            orgs.forEach( (element: any) => {
                if (i === 0 && this.state.isHeader) {
                    // skip header
                } else {
                let data = {
                    index: i + 1,
                    name: element[0] !== undefined ? element[0] : '',
                    contact_fname: element[1] !== undefined ? element[1] : '',
                    contact_lname: element[2] !== undefined ? element[2] : '',
                    contact_phone: element[3] !== undefined ? element[3] : '',
                    contact_email: element[4] !== undefined ? element[4] : '',
                    address: element[5] !== undefined ? element[5] : '',
                    city: element[6] !== undefined ? element[6] : '',
                    state: element[7] !== undefined ? element[7] : '',
                    country: element[8] !== undefined ? element[8] : '',
                    pincode: element[9] !== undefined ? element[9] : '',
                    email: element[10] !== undefined ? element [10] : '',
                    website: element[11] !== undefined ? element[11] : '',
                    error: ''
                };
                columnData.push(data);
                }
                i += 1;
            }); 
        }
        return columnData;
    }

    /**
     * Validates the data retrived from uploaded csv file
     * @param data CSV Data to be validated
     */
    private validateData(data: any) {
        let errorRows: any = [];
        errorRows = data.filter((e: any) => { // get the error rows
            let isError: boolean = false;
            for (let key of Object.keys(e)) {
                if ( REQUIREDKEYS.indexOf(key) > -1 ) {
                    if (e[key] !== undefined && e[key]  !== null && e[key].toString().trim() === '') {
                        isError = true;
                        e[key] = ERRORMSG;
                    } else if (e[key]  === undefined || e[key]  === null ) {
                        isError = true;
                        e[key] = ERRORMSG;
                    } 
                }
            }
            return isError;
        });
        return errorRows;
    }

    /**
     * This function is called when Upload button is clicked.
     * Data is sent to server for uploading.
     */
    private async uploadOrganizations() {
        this.setState({ 
            btnDisable: true,
            clearBtnDisable: true 
        });
        let orgs: any = this.getOrgObj();
        let blb: any = new Blob([JSON.stringify(orgs)], { type: 'text/plain' });
        // let file = new File([blb], 'text.txt');
        let file = blb;
        // file.name = 'test.txt';
        console.log('file', file);
        let ser = new dataservice();
        let resp = await ser.uploadOrganizations(file, storage.getSelectedOrgPrimary());
        this.setState({ 
            btnDisable: false,
            clearBtnDisable: false
         });
        console.log('upload orgs response', resp);
        if (resp !== null && resp[0].status === 0) {
            message.success(this.state.columnData.length + ' Organization(s) uploaded successfully'!);
            this.clearForm();
            this.props.notifyOrgStatusChange();
        } else {
            this.displayErrors(resp);
            this.props.notifyOrgStatusChange();
        }
    }

    /**
     * This function is called if validation of data fails from server side
     * It handles display of errors in data on UI.
     * @param resp Server response
     */
    private displayErrors(resp: any) {
        let data: any = [];
        console.log('data', this.state.columnData);
        this.state.columnData.forEach((e: any, dataIndex: number) => {
            console.log('e', e);
            for (let i = 0; i < resp.length; i++) {
                if (resp[i].index === e.index) {
                    console.log('matched', e.index);
                    e.error = resp[i].message; 
                    data.push(e);
                    console.log('data index', data);
                    break;
                }                    
            }
        });
        console.log('data', data);
        console.log('pagination', this.state.pagination);
        let sucessOrgCount: number = this.state.columnData.length - data.length ;
        let pagination: any = this.state.pagination;
        pagination.total = data.length;
        this.setState({
            columnData: data,
            columns: this.buildColumns(true),
            isValidationError: true,
            pagination,
            successCount: sucessOrgCount
        });
        
        message.error(sucessOrgCount + ' Organization(s) uploaded successfully!');
    }

    /**
     * Returns organization object in json format
     * to be sent to server for processing
     */
    private getOrgObj(): any {
        let orgs: any = [];
        this.state.columnData.forEach((e: any) => {
            let inputOrg: any = {
                'index': e.index,
                'name': e.name !== null ? e.name.trim() : '',
                'contactfirstname': e.contact_fname !== null ? e.contact_fname.trim() : '',
                'contactlastname': e.contact_lname !== null ? e.contact_lname.trim() : '',
                'contactphone': e.contact_phone !== null ? e.contact_phone.trim() : '',
                'contactemail': e.contact_email !== null ? e.contact_email.trim() : '',
                'address': e.address !== null && e.address !== undefined
                                     ? e.address.trim() : '',
                'city': e.city !== null && e.city !== undefined
                            ? e.city.trim() : '',
                'state': e.state !== null && e.state !== undefined
                            ? e.state.trim() : '',
                'country': e.country !== null && e.country !== undefined
                            ? e.country.trim() : '',
                'pincode': e.pincode !== null && e.pincode !== undefined
                            ? e.pincode.trim() : '',
                'email': e.email !== null && e.email !== undefined 
                                     ? e.email.trim() : '',
                'website': e.website !== null && e.website !== undefined
                                     ? e.website.trim() : ''
            };  
            orgs.push(inputOrg);
        });
        console.log('orgs', orgs);
        return orgs;
    }

    /**
     * Clears the page
     */
    private clearForm() {
        let elm: any = document.getElementsByClassName('csv-input')[1];
        elm.value = '';
        let pagination = this.state.pagination;
        pagination.total = 0;
        this.setState({
            rosterName: '',
            columns: [],
            columnData: [],
            loading: false,
            isHeader: false,
            pagination: pagination,
            isError: false,
            showInfo: true,
            successCount: 0,
            isValidationError: false
        });
    }

    /**
     * Sets and returns the columns for the information table.
     */
    private getInfoColumns() {
        let columns = [
            {
              title: 'Column',
              dataIndex: 'column',
              className: 'rows'
            },
            {
              title: 'Description',
              dataIndex: 'description',
              className: 'rows'
            },
            {
              title: 'Required',
              dataIndex: 'required',
              className: 'rows'
            }];
        return columns;
    }

    /**
     * Sets and returns the data for Information table.
     */
    private getInfoData() {
        let columnData: Array<any> = [];
        columnData = [
        {
            column: 'Name',
            description: 'Name',
            required: 'Yes',
        }, {
            column: 'Contact First Name',
            description: 'Contact First Name',
            required: 'Yes',
        }, {
            column: 'Contact Last Name',
            description: 'Contact Last Name',
            required: 'Yes',
        }, {
            column: 'Contact Phone',
            description: 'Contact Phone Number',
            required: 'Yes',
        }, {
            column: 'Contact Email',
            description: 'Contact Email Address',
            required: 'Yes',
        }, {
            column: 'Address',
            description: 'Address',
            required: 'No',
        }, {
            column: 'City',
            description: 'Address',
            required: 'No',
        }, {
            column: 'State',
            description: 'State',
            required: 'No',
        }, {
            column: 'Country',
            description: 'Country',
            required: 'No',
        }, {
            column: 'Zip/Postal Code',
            description: 'Zip/Postal Code',
            required: 'No',
        }, {
            column: 'Email',
            description: 'Email',
            required: 'No',
        }, {
            column: 'Website',
            description: 'Website',
            required: 'No',
        }
        ];
        console.log('columnData', columnData);
        return columnData;
    }

    // private validateDublicate(orgs: any) {
    //     let orgNames: any = [];

    //     for (let i = 0; i < orgs.length; i++) {
    //         orgNames.push(orgs[i].name);
    //     }
    //     let invalidOrgs: any = [];
    //     orgs.map(org => {
    //         let count: number = 0;
    //         orgNames.map(n => {
    //             if (org.name === n) {
    //                 count++;
    //             }
    //             // check for duplicate usernames.
    //             if (count > 1) {              
    //                 invalidOrgs.push(org);
    //             } 
    //         });
    //     });
    //     return invalidOrgs;
    // }

}


// WEBPACK FOOTER //
// ./src/components/organization/OrganizationBulkUpload.tsx